import { css } from 'aphrodite';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '../../../../../components-v2/Input';
import { styleSheet } from '../../styles';
import { IFormValues } from './types';

interface PreviewAttendeeInfoFieldsProps {
	requirePhoneNumber?: boolean;
}

export const PreviewAttendeeInfoFields: React.FC<PreviewAttendeeInfoFieldsProps> = ({ requirePhoneNumber = false }) => {
	const { control } = useFormContext<IFormValues>();

	return (
		<div className={css(styleSheet.rsvpInfo)}>
			<div className={css(styleSheet.formControl)}>
				<label htmlFor='client-firstName' className={css(styleSheet.label)}>
					First Name <span className={css(styleSheet.required)}>*</span>
				</label>
				<Controller
					name='firstName'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<Input
							autoComplete='off'
							id='client-firstName'
							name='firstName'
							type='text'
							disabled
							placeholder='PREVIEW ONLY'
							{...fieldProps}
						/>
					)}
				/>
			</div>

			<div className={css(styleSheet.formControl)}>
				<label htmlFor='client-lastName' className={css(styleSheet.label)}>
					Last Name <span className={css(styleSheet.required)}>*</span>
				</label>
				<Controller
					name='lastName'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<Input
							autoComplete='off'
							id='client-lastName'
							name='lastName'
							type='text'
							disabled
							placeholder='PREVIEW ONLY'
							{...fieldProps}
						/>
					)}
				/>
			</div>

			<div className={css(styleSheet.formControl)}>
				<label htmlFor='client-email' className={css(styleSheet.label)}>
					Email <span className={css(styleSheet.required)}>*</span>
				</label>
				<Controller
					name='email'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<Input
							autoComplete='off'
							id='client-email'
							type='text'
							disabled
							placeholder='PREVIEW ONLY'
							{...fieldProps}
						/>
					)}
				/>
			</div>

			<div className={css(styleSheet.formControl)}>
				<label htmlFor='client-phone' className={css(styleSheet.label)}>
					Phone{' '}
					{!requirePhoneNumber ? (
						<small className={css(styleSheet.optionalText)}>(Optional)</small>
					) : (
						<span className={css(styleSheet.required)}>*</span>
					)}
				</label>
				<Controller
					name='phone'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<Input
							autoComplete='off'
							id='client-phone'
							type='text'
							disabled
							placeholder='(999)999-9999 PREVIEW ONLY'
							{...fieldProps}
						/>
					)}
				/>
			</div>
		</div>
	);
};
